import { render, staticRenderFns } from "./JukiAccordion.vue?vue&type=template&id=3f82f708&"
import script from "./JukiAccordion.vue?vue&type=script&lang=js&"
export * from "./JukiAccordion.vue?vue&type=script&lang=js&"
import style0 from "./JukiAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports